/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", function () {
    // Add custom code below this line

    const swiper = new Swiper(".swiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    const swiperhistory = new Swiper(".swiper-history", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    const swiperranking = new Swiper(".swiperranking", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    const swipercollection = new Swiper(".swipercollection", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    const swipertab = new Swiper(".swipertab", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    const swiperlatest = new Swiper(".swiperlatest", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });


      // PC用スライダー
      const fadeSlidePc = new Swiper(".fade_slide_pc", {
        loop: true,
        effect: "fade", // フェード切り替え
        // 自動再生
        autoplay: {
          delay: 4000, // 4秒後に次のスライドへ
          disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
        },
        speed: 2000, // 2秒かけてフェード
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    
      // SP用スライダー
      const fadeSlideSp = new Swiper(".fade_slide_sp", {
        loop: true,
        effect: "fade", // フェード切り替え
        // 自動再生
        autoplay: {
          delay: 4000, // 4秒後に次のスライドへ
          disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
        },
        speed: 2000, // 2秒かけてフェード
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });

    // ^^ Keep your scripts inside this callback function to
    // avoid executing them before the document is fully loaded.
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


//
document.addEventListener("DOMContentLoaded", () => {
  let isComposing = false;

  // カートボタン（一般的なセレクタ）※ポップアップ内を除外
  const getAddToCartButtons = () =>
    [...document.querySelectorAll(
      'button[type="submit"], button[name="add"], [data-add-to-cart]'
    )].filter(btn => !btn.closest('.pop-up'));

  // 名入れ input（name 属性で拾う）
  const getTargetInputs = () =>
    document.querySelectorAll('input[name^="properties["]');

  // 入力チェック
  const validate = () => {
    let isValid = true;

    getTargetInputs().forEach(input => {
      const max = Number(input.dataset.maxlength);
      if (!max) return;

      if (input.value.length > max) {
        isValid = false;
      }
    });

    // ボタン制御
    getAddToCartButtons().forEach(btn => {
      btn.disabled = !isValid;
      btn.style.opacity = isValid ? "1" : "0.5";
      btn.style.pointerEvents = isValid ? "auto" : "none";
    });
  };

  // IME対応
  document.addEventListener("compositionstart", () => {
    isComposing = true;
  });

  document.addEventListener("compositionend", () => {
    isComposing = false;
    validate();
  });

  // 通常入力
  document.addEventListener("input", e => {
    if (isComposing) return;
    if (e.target.matches('input[name^="properties["]')) {
      validate();
    }
  });

  // 初期化：input ごとに最大文字数を割り当てる
  getTargetInputs().forEach(input => {
    // 例：name 属性に応じて最大文字数を変える
    if (input.name.includes("名入れ")) {
      input.dataset.maxlength = "5";
    } else if (input.name.includes("メッセージ")) {
      input.dataset.maxlength = "10";
    }
  });

  // 初回チェック
  validate();
});





